import { JSX } from 'react';

const MarketShareSkeleton = (): JSX.Element => {
  return (
    <div className="skeleton market-opportunity_market-share-skeleton" data-testid="market-share-skeleton">
      <div className="market-share-skeleton__split-container">
        <div className="market-share-skeleton__chart-half">
          <div className="market-share-skeleton__pie-chart" />
        </div>
        <div className="market-share-skeleton__legend-half">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="market-share-skeleton__list">
              <div className="bone list-color-indicator" />
              <div className="bone list-name-indicator" style={{ width: `${50 + (i % 3) * 15}%` }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarketShareSkeleton;